<template>
    <button class="btn btn-sm btn-xs btn-success"
            :disabled="hasUseablePasscode"
            @click="confirmAddCrewMedicalDeclaration"
            v-if="crew.active == 1 || isSystemAdmin"
    >
        <span class="fas fa-plus-square"></span>
        Generate Passcode
    </button>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";

import { DateService } from "@/services/Utilities/DateService";
import {gateMixin} from "@/mixins/gateMixin";

export default {
    name: "CrewHealthChecklistPasscode",

    mixins: [ vueAppMixin, gateMixin ],

    methods: {
        ...mapActions([ 'addCrewMedicalDeclaration' ]),

        async confirmAddCrewMedicalDeclaration() {
            if(await this.confirmCreateAlert()) {
                let params = {
                    crewId: this.crew.id
                };
                let newCrewMedicalDeclaration = await this.addCrewMedicalDeclaration(params);
                if (newCrewMedicalDeclaration && !newCrewMedicalDeclaration.errors) {
                    this.successAlert('Crew Medical Declaration Successfully Saved', 'SAVE');
                }
            }
        }
    },

    computed: {
        ...mapGetters([ 'crew', 'crewMedicalDeclarations' ]),

        hasUseablePasscode() {
            let useablePasscode = false;
            if(this.crewMedicalDeclarations.length) {
                let generatedDate = new Date(Date.parse(this.crewMedicalDeclarations[0].createdAt));
                let dateDifference = DateService.getDateDifference(generatedDate, new Date());
                useablePasscode = this.crewMedicalDeclarations[0].daysToExpire === 'N/A' && dateDifference < 15;
            }

            // this.crewMedicalDeclarations.forEach(crewMedicalDeclaration => {
            //     if(crewMedicalDeclaration.daysToExpire == 'N/A') {
            //         useablePasscode = true;
            //     }
            // });
            return useablePasscode;
        }

    }

}
</script>

<style scoped>

</style>